// Module
var code = "<div class=\"report-header compact\">\n    <div class=\"tool-header-info\">\n        <div class=\"tool-header-name\">Import from Excel</div>\n    </div>\n</div>\n<div class=\"notification-area\"></div>\n<div class=\"upload-area wide-uploader-support\">\n    <div class=\"upload-wrapper\"></div>\n</div>\n";
// Exports
module.exports = code;